import { ChevronDown, ChevronUp } from "lucide-react";

export const handleChevron = (isActive: boolean) => isActive ? <ChevronUp /> : <ChevronDown />; 
